/* Stylesheet */

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    transform: translateY(-12px);
    opacity: 0.5;
  }
}

.initial_segment {
  display: flex;
  height: 84.5svh;
  align-items: center;

  .block_container {
    margin: 0 auto;

    .label_container {
      margin: 0px 0px 32px 0px;
      line-height: 2;

      .label {
        font-size: 1.125rem;
        color: var(--ion-color-text-primary);

        span {
          font-weight: 600;
        }

        .dot_loader {
          margin: 0px 0px 0px 8px;
          display: inline-flex;
          gap: 6px;
          align-items: center;

          .dot {
            height: 8px;
            width: 8px;
            border-radius: 50%;
            animation: bounce 1.25s infinite ease-in-out;

            &:nth-child(1) {
              animation-delay: 0s;
              background: var(--ion-color-dark-primary);
            }

            &:nth-child(2) {
              animation-delay: 0.2s;
              background: var(--ion-color-primary);
            }

            &:nth-child(3) {
              animation-delay: 0.4s;
              background: var(--ion-color-secondary);
            }
          }
        }
      }
    }
  }
}
